import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals, { logToConsole, sendToPlausible } from './utils/webVitals';
import './index.css';

// Register service worker for offline support
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(registration => {
        console.log('SW registered:', registration.scope);
      })
      .catch(error => {
        console.log('SW registration failed:', error);
      });
  });
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// Report Web Vitals - log to console in development
reportWebVitals(logToConsole);

// Also send to Plausible analytics in production
if (process.env.NODE_ENV === 'production') {
  reportWebVitals(sendToPlausible);
}
